import { createBrowserHistory } from "history";

let history = null;

if (process.env.NODE_ENV === "test") {
  history = {
    push: () => null,
    listen: () => null,
    location: {
      pathname: "/",
      listen: () => null,
    },
  };
} else {
  history = createBrowserHistory();
}

export { history };
